import React from 'react';
import NotificationCard from './NotificationCard';
import { Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import './NotificationDropdown.css';

const NotificationDropdown = ({ 
    notifications, 
    onMarkAllRead, 
    onNotificationClick, 
    onClose,
    onLoadMore,
    hasMore,
    isMoreLoading
}) => {
    const navigate = useNavigate();

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 50 && hasMore && !isMoreLoading) {
            onLoadMore();
        }
    };

    return (
        <div className="notification-dropdown">
            <div className="notification-dropdown-header">
                <h3>Notifications</h3>
                <button className="mark-all-btn" onClick={onMarkAllRead}>
                    Mark all as read
                </button>
            </div>
            <div className="notification-dropdown-list" onScroll={handleScroll}>
                {notifications.length > 0 ? (
                    <>
                        {notifications.map(item => (
                            <NotificationCard 
                                key={item.id} 
                                item={item} 
                                onClick={onNotificationClick} 
                            />
                        ))}
                        {isMoreLoading && (
                            <div className="dropdown-load-more">
                                <div className="spinner"></div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="empty-notifications">
                        No notifications yet
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationDropdown;
